<template>
	<v-sheet color="transparent">
			<h2 class="cn-font grey--text mb-3">Gesamtdelegation</h2>
			<p>Die Schnelldelegation ermöglicht es Ihnen, Erhebungsteile nach unserem vordefinierten Schema an an Andere zu delegieren und somit mühelos die sachgerechte Bearbeitung der Reigfegraderhebung zu gewähleisten Mehr informationen zum Schema finden sie hier.</p>
			<p> Zur Benutzung der Schnelldelegation weisen Sie den folgenden Fachbereichen jeweils einen Verantwortlichen zu: </p>
			<v-list color="transparent">
			
				<v-list-item class="elevation-1 mb-2 white--background" v-for="subject in Object.keys(subject_collaborations)" :key="subject">
					<v-list-item-title>{{subject}}</v-list-item-title>
					<v-list-item-action>
						<v-chip  v-if="subject_users[subject]" @click="display_dialog = 1" class="pr-8 mt-2" color="accent" close @click:close="removeUser(subject)">
							<v-avatar left>
								<v-img  v-if="subject_users[subject].profile_image" :src="subject_users[subject].profile_image"></v-img>
								<v-icon color="white" v-else>mdi-account-circle</v-icon>
							</v-avatar>
							{{ subject_users[subject].display_name }}
						</v-chip>
						<SelectSubjectCollaborationUser  v-else  :subject="subject"></SelectSubjectCollaborationUser>
						
						<v-dialog v-model="display_dialog" width="400px">
							<DisplayUser :user="subject_users[subject]"></DisplayUser>
						</v-dialog>	
					</v-list-item-action>
				</v-list-item>
			</v-list>
			<v-card-actions>
				<BackButton></BackButton>
				<v-spacer></v-spacer>
				<v-btn text rounded color="red">Abbrechen</v-btn>
				<v-btn color="primary" :disabled="!valid" rounded>Schnelldelegation Bestätigen</v-btn>
			</v-card-actions>
	</v-sheet>

</template>

<style lang="less">
	
</style>
<script type="text/javascript">
	import Vuex from "vuex";
	import DisplayUser from "@/components/assessment/users/DisplayUser"
	import SelectSubjectCollaborationUser from "@/components/assessment/collaborations/SelectSubjectCollaborationUser"
	import BackButton from "@/components/elements/BackButton"
	export default {
		name: "Schnelldelegation", 
		props: {
			
		},
		data: () => {
			return {
				display_dialog: false,
				selectedUser: false
			}
		},
		components: {
			BackButton,
			DisplayUser,
			SelectSubjectCollaborationUser
		},
		computed: {
			...Vuex.mapState({
				users: state=>state.users, 
				assessments: state => state.assessments
			}), 
			subject_collaborations(){
				if( !this.assessments[0] ){
					return {}
				}
				return this.assessments[0].subject_collaborations
			},
			subject_users(){
				var u = {}  
				for( var key in this.subject_collaborations ){
					u[key] = this.findUser(this.subject_collaborations[key]);
				}
				return u
			},
			valid(){
				return Object.values(this.subject_users).filter(a => !a).length == 0
			}
		},
		methods: {
			findUser(id){
				return this.users.find( u => u.id == id )
			},
			removeUser(subject){
				this.$store.dispatch("assessments/removeSubjectUser", subject )
			},
		}
		// created(){
			
		// }

	}
</script>